export const U64_MAX = 18446744073709551615n; // 2 ** 64 - 1;
export const I64_MAX = 9223372036854775807n; // 2 ** 63 − 1.
export const I64_MIN = -9223372036854775808n; // -2 ** 63
export const MINT_AMOUNT_MAX = I64_MAX;
export const MINT_AMOUNT_MIN = I64_MIN;
export const POLICY_ID_LENGTH = 56;
export const OGMIOS_ASSET_ID_SEPARATOR = ".";
export const CARDANO_ADA_ASSET_ID = "";
//# sourceMappingURL=constants.js.map